import { ClassConstructor } from "class-transformer";
import { cloneDeep } from "lodash";
import Vue from "vue";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";

import { WizardLikeList } from "../../../../../components/WizardLikeSelect/types";
import { IterableListItem } from "../../../../../shared/utils/IterableItemFactory";
import { PostActionTypeEnum } from "../../types";
import EditPostActionModel from "../ActionTypes/EditPostAction/EditPostActionModel";
import { PostActionBuilder } from "../ActionTypes/PostActionBuilder";
import { PostActionModel } from "../ActionTypes/PostActionModel";
import { PostActionStructure } from "../ActionTypes/PostActionStructure";

@Component({})
export default class SelectPostActionModalMixin<T extends PostActionStructure> extends Vue {
    @Prop({ type: Array, required: true, default: () => [] }) actions!: Array<IterableListItem<PostActionStructure>>

    @Prop() currentAction!: T | null

    @Prop() disabled!: boolean

    @Prop() postMessage!: any

    @Prop({ type:Boolean, default: false }) validateActions!:boolean

    @Prop() builders!: Record<PostActionTypeEnum, PostActionBuilder>

    @Emit()
    updateAction<T extends PostActionStructure>(localActions: T) {
        return localActions
    }

    @Emit()
    resetState() {
        return null
    }

    @Watch('currentAction')
    onCurrentActionChange(value: T | null) {
        if (value) {
            this.currentKey = value.action.type
        } else {
            this.currentKey = value
        }
    }

    actionCopy: PostActionStructure | null = null

    isModalOpen = false

    currentKey: PostActionModel['type'] | null = null

    get items(): WizardLikeList {
      if (this.builders) {
        return [
          {
            type: "Simple",
            items: Object.values(this.builders).map(builder => {
              const actionTitle = builder.actionTitle()
              const actionHelpMessage = builder.actionHelpMessage()
              const disabledMessage = builder.disabledMessage()

              return {
                key: builder.type,
                title: this.$t(actionTitle.key, actionTitle.params).toString(),
                helpMessage: this.$te(actionHelpMessage.key) ? this.$t(actionHelpMessage.key, actionHelpMessage.params).toString() : null,
                icon: builder.icon,
                disabled: {
                  state: () => builder.isDisabled() && this.validateActions,
                  helpMessage: this.$te(disabledMessage.key) ? this.$t(disabledMessage.key, disabledMessage.params).toString() : null,
                },
                isVisible: builder?.isVisible ?? true
              }
            })
          }
        ]
      }

      return []
    }

    onSelectItem(type: PostActionTypeEnum, classConstructor: ClassConstructor<T>) {
        if (this.currentAction && this.currentAction.action.type === type) {
            this.actionCopy = cloneDeep(this.currentAction)
        } else {
            const builder = this.builders[type]

            if (builder) {
                const postAction = builder.createAction(classConstructor)

                if (this.postMessage && postAction.action instanceof EditPostActionModel) {
                    postAction.action.message = cloneDeep(this.postMessage)
                }

                if (postAction) {
                    this.actionCopy = cloneDeep(postAction)
                }
            }
        }
    }

    onSaveClick() {
        if (this.actionCopy) {
            this.updateAction(this.actionCopy)
        }
    }
}
